/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import { MarkdownEditor, MarkdownEditorProps } from '@aws/threat-composer';
import { FC, useState } from 'react';
import { unstable_usePrompt } from 'react-router-dom';

const MarkdownEditorWithPrompt: FC<MarkdownEditorProps> = ({
  value, ...props
}) => {
  const [previousValue] = useState(value);

  unstable_usePrompt({
    message: 'You have unsaved changes, proceed anyway?',
    when: ({ currentLocation, nextLocation }) =>
      previousValue !== value &&
      currentLocation.pathname !== nextLocation.pathname,
  });

  return <MarkdownEditor value={value} {...props} />;
};

export default MarkdownEditorWithPrompt;